
import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate, CanDeactivate } from '@angular/router';

// tslint:disable-next-line: max-line-length
import { QuoteVariantsComponent, QuotePlaybackComponent, ProductQuoteComponent, YourSaveQuoteComponent,UserRegistrationComponent } from '../quote-calculation';
import { CreateQuoteSubmittedCanDeativeGuard } from './components/product-quote/create-quote-submitted-can-deative-quard.guard';
import { AuthGuardGuard } from '../../shared/guards/auth-guard.guard';
import { GmpAnnuityQuoteComponent } from './components/product-quote/gmp-annuity-quote/gmp-annuity-quote.component';
import { cmsServiceMapperResolver } from 'src/app/shared/services/api-services/cms-service-mapper.resolver';
import { uiCompJsonResolver } from 'src/app/shared/services/api-services/ui.comp.json.resolver';
import { configDataResolver } from 'src/app/shared/services/api-services/config-data.json.resolver';


const quoteRoutes: Routes = [
  // {
  //   path: 'youroptionscalculation', // Path is defined in parent
  //   component: YourOptionsCalculationComponent
  // },
  {
    path: 'your-product-options', // Path is defined in parent
    component: QuoteVariantsComponent,
    data: {
      title: 'Online Quote - Option & Quote'
    }
    /* ,
    resolve: {configJson: configDataResolver } */
    // canDeactivate: [CreateQuoteSubmittedCanDeativeGuard],
  },
  {
    path: 'please-confirm-your-details',
    component: QuotePlaybackComponent,
    data: {
      title: 'Online Quote - Quote Playback'
    }
  },
  {
    path: 'your-product-quote',
    component: ProductQuoteComponent,
    canDeactivate: [CreateQuoteSubmittedCanDeativeGuard],
    canActivate: [AuthGuardGuard],
    data: {
      title: 'Online Quote - Product Quote'
    },
    resolve: { cmsJson: cmsServiceMapperResolver }
  },
  {
    path: 'your-saved-quotes',
    component: YourSaveQuoteComponent,
    canActivate: [AuthGuardGuard],
    data: {
      title: 'Online Quote - Quote Summary'
    },
    resolve: { cmsJson: cmsServiceMapperResolver }
  },
  {
    path: 'test',
    component: UserRegistrationComponent,
    data: {
      title: 'Online Quote - User Registration'
    }
  }

];

@NgModule({
  imports: [
    RouterModule.forChild(quoteRoutes)
  ],
  exports: [
    RouterModule
  ],
  declarations: [],
  providers: [cmsServiceMapperResolver]
})

export class QuoteCalculationRouteModule { }
